const INIT_STATE = {
  isModalActive: true,
  isModalLoading: false,
  data: null,
  error: null,
};

export default function modalReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case '@oms/SHOW_BARCODE_SCAN_MODAL': {
      return {
        ...state,
        isModalActive: action.payload,
      };
    }

    case '@oms/LOADING_BARCODE_SCAN_MODAL': {
      return {
        ...state,
        isModalLoading: action.payload,
      };
    }

    case '@oms/SET_BARCODE_SCAN_DATA': {
      return {
        ...state,
        data: action.payload,
        error: action.error,
      };
    }

    default: {
      return state;
    }
  }
}
